define([
    "./userManagementLGPDModule",
    "./userManagementLgpdApi",
    "./userManagementLGPDConfiguration"
], function () {
});